import * as React from 'react';
import { TranslationService } from "../../common";
import { QuestionnaireEvaluationQuestionType } from "../../questionnaireEvaluation";
import { BrandedNotificationWorkflowTypes, BrandedNotificationWorkflowSubTypes } from "../../brandedNotification";
import { GPCLoaderConstants, IntelligentPhotoCatureImageConstant } from '../constants';
import { GuidedPhotoCapture, PhotoCaptureMessageType } from '../enums';
import { isDeviceLibraryDisabled } from '../utilities';
import { IntelligentPhotoCaptureLoading } from './intelligentComponents';
export const GPCLoader = ({ coCode, contextId, language, workItemStatus, evaluationDocId, questionnaireId, underWritingCompanyName, questionnaireQuestionId, qustnnrVrsnChng, isQuestionnaireUpdated, disableLibrary, isLinkExpired, isSessionExpired, photoCaptureGetAuthenticationDataAction, questionnaireEvaluationInitializationPostAction, onGPCSuccess, onGPCError, questionnaireEvaluationQuestionGetAction, isMic, questionList }) => {
    const [isInitialized, setIsInitialized] = React.useState(false);
    const translateFn = TranslationService.translate;
    const questionnaireEvaluationRequestData = {
        mapSysQustnCdsAndValues: {
            underwriting_company: underWritingCompanyName
        },
        qustnnrId: questionnaireId,
        evalDocId: evaluationDocId,
        userAnswrdSystmQustn: null,
        coCode: coCode
    };
    const loadQuestionType = isDeviceLibraryDisabled(disableLibrary)
        ? QuestionnaireEvaluationQuestionType.FIRST
        : QuestionnaireEvaluationQuestionType.NEXT;
    React.useEffect(() => {
        const notificationType = 'NONE';
        const brandedNotificationInputs = {
            notificationLanguage: language,
            workflowType: BrandedNotificationWorkflowTypes.PHOTO_CAPTURE,
            workflowSubType: BrandedNotificationWorkflowSubTypes.APPLICATION,
            notificationType: notificationType,
            underWritingCompany: '',
            contentType: ''
        };
        photoCaptureGetAuthenticationDataAction(coCode, contextId, brandedNotificationInputs);
    }, []);
    React.useEffect(() => {
        if (workItemStatus && workItemStatus !== GuidedPhotoCapture.TASK_STATUS_OPENED) {
            setIsInitialized(true);
            onGPCError(workItemStatus);
        }
    }, [workItemStatus]);
    React.useEffect(() => {
        if (isLinkExpired) {
            setIsInitialized(true);
            onGPCError(PhotoCaptureMessageType.LINK_EXPIRED);
        }
    }, [isLinkExpired]);
    React.useEffect(() => {
        if (isSessionExpired) {
            setIsInitialized(true);
            onGPCError(PhotoCaptureMessageType.SESSION_EXPIRED);
        }
    }, [isSessionExpired]);
    React.useEffect(() => {
        isQuestionnaireUpdated &&
            !isLinkExpired &&
            qustnnrVrsnChng &&
            evaluationDocId &&
            evaluationDocId !== GPCLoaderConstants.DEFAULT_EVALUATION_DOCID &&
            questionnaireId &&
            questionnaireEvaluationQuestionGetAction({
                companyCode: coCode,
                evaluationDocId: parseInt(evaluationDocId),
                questionnaireId: parseInt(questionnaireId),
                questionnaireQuestionId: questionnaireQuestionId || 0,
                questionType: loadQuestionType
            });
    }, [qustnnrVrsnChng, isQuestionnaireUpdated]);
    React.useEffect(() => {
        qustnnrVrsnChng && questionnaireEvaluationInitializationPostAction(questionnaireEvaluationRequestData);
    }, [qustnnrVrsnChng]);
    React.useEffect(() => {
        evaluationDocId && evaluationDocId !== GPCLoaderConstants.DEFAULT_EVALUATION_DOCID
            ? !isLinkExpired &&
                questionnaireId &&
                questionnaireEvaluationQuestionGetAction({
                    companyCode: coCode,
                    evaluationDocId: parseInt(evaluationDocId),
                    questionnaireId: parseInt(questionnaireId),
                    questionnaireQuestionId: questionnaireQuestionId || 0,
                    questionType: loadQuestionType
                })
            : questionnaireId && questionnaireEvaluationInitializationPostAction(questionnaireEvaluationRequestData);
    }, [evaluationDocId, questionnaireId]);
    React.useEffect(() => {
        if (evaluationDocId && questionnaireId && questionnaireQuestionId) {
            setIsInitialized(true);
            onGPCSuccess();
        }
        if (questionList.length && !questionList[0]) {
            setIsInitialized(true);
        }
    }, [questionnaireQuestionId, questionList]);
    return (React.createElement(React.Fragment, null, !isInitialized && (React.createElement(IntelligentPhotoCaptureLoading, { logoSrc: IntelligentPhotoCatureImageConstant.photoCaptureLoader.image, altText: translateFn(IntelligentPhotoCatureImageConstant.photoCaptureLoader.altText), loadingMessage: translateFn(IntelligentPhotoCatureImageConstant.photoCaptureLoader.loadingMessage), title: translateFn(IntelligentPhotoCatureImageConstant.photoCaptureLoader.title), isMic: isMic }))));
};
//# sourceMappingURL=GPCLoader.js.map